"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _RecruitmentForm = _interopRequireDefault(require("./components/RecruitmentForm"));
var _apolloClient = require("@/apollo/apolloClient");
var _recruitmentMutation = require("@/apollo/mutations/recruitment-mutation");
var _auth = require("@/utils/auth");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RecruitmentForm: _RecruitmentForm.default
  },
  data: function data() {
    return {
      waitDialogVisible: false,
      form: {
        store_name: '',
        // 店名
        contact_name: '',
        // 担当者名
        phone_number: '',
        // 電話番号
        mail_address: '',
        // メールアドレス
        occupation: '',
        // 職種
        site_address: '',
        // 現場住所
        start_period_date: null,
        // 期間（開始）
        end_period_date: null,
        // 期間（終了）
        shift: '',
        // シフト内容
        staff_count: '',
        // 募集人数
        working_hours: '',
        // 勤務時間
        holiday: '',
        // 休日
        reception: '',
        // 待遇
        reason: '',
        // 募集理由
        workplace_composition: '',
        // 職場構成
        prerequisite_type: '',
        // 働く上での必須条件（性格）
        prerequisite_spec: '',
        // 働く上での必須条件（資格）
        condition_type: '',
        // 働く上でのでlきれば必要な条件（性格）
        condition_spec: '',
        // 働く上でのでlきれば必要な条件（資格）
        job_description: '' // 仕事内容
      },
      showForm: {
        store_name: true,
        // 店名
        contact_name: true,
        // 担当者名
        phone_number: true,
        // 電話番号
        mail_address: true,
        // メールアドレス
        occupation: true,
        // 職種
        site_address: true,
        // 現場住所
        start_period_date: true,
        // 期間（開始）
        end_period_date: true,
        // 期間（終了）
        shift: true,
        // シフト内容
        staff_count: true,
        // 募集人数
        working_hours: true,
        // 勤務時間
        holiday: true,
        // 休日
        reception: true,
        // 待遇
        reason: true,
        // 募集理由
        workplace_composition: true,
        // 職場構成
        prerequisite_type: true,
        // 働く上での必須条件（性格）
        prerequisite_spec: true,
        // 働く上での必須条件（資格）
        condition_type: true,
        // 働く上でのでlきれば必要な条件（性格）
        condition_spec: true,
        // 働く上でのでlきれば必要な条件（資格）
        job_description: true // 仕事内容
      },
      submitBtnName: '新規作成',
      loading: false
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return (0, _appUtil.checkReadingFlag)(true);
          case 1:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    backToRecruitmentIndex: function backToRecruitmentIndex() {
      return this.$router.push({
        name: 'RecruitmentIndex'
      });
    },
    insertRecruitment: function () {
      var _insertRecruitment = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(form) {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('insertRecruitment');
              _context3.next = 1;
              return _apolloClient.apolloClient.mutate({
                mutation: _recruitmentMutation.CREATE_RECRUITMENT,
                variables: {
                  client_uuid: (0, _auth.getUUID)(),
                  // UUID
                  store_name: this.$data.form.store_name,
                  // 店名
                  contact_name: this.$data.form.contact_name,
                  // 担当者名
                  phone_number: this.$data.form.phone_number,
                  // 電話番号
                  mail_address: this.$data.form.mail_address,
                  // メールアドレス
                  occupation: this.$data.form.occupation,
                  // 職種
                  site_address: this.$data.form.site_address,
                  // 現場住所
                  start_period_date: this.$data.form.start_period_date,
                  // 期間（開始）
                  end_period_date: this.$data.form.end_period_date,
                  // 期間（終了）
                  shift: this.$data.form.shift,
                  // シフト内容
                  staff_count: this.$data.form.staff_count,
                  // 募集人数
                  working_hours: this.$data.form.working_hours,
                  // 勤務時間
                  holiday: this.$data.form.holiday,
                  // 休日
                  reception: this.$data.form.reception,
                  // 待遇
                  reason: this.$data.form.reason,
                  // 募集理由
                  workplace_composition: this.$data.form.workplace_composition,
                  // 職場構成
                  prerequisite_type: this.$data.form.prerequisite_type,
                  // 働く上での必須条件（性格）
                  prerequisite_spec: this.$data.form.prerequisite_spec,
                  // 働く上での必須条件（資格）
                  condition_type: this.$data.form.condition_type,
                  // 働く上でのでlきれば必要な条件（性格）
                  condition_spec: this.$data.form.condition_spec,
                  // 働く上でのでlきれば必要な条件（資格）
                  job_description: this.$data.form.job_description // 仕事内容
                }
              }).then(function (result) {
                _apolloClient.apolloClient.resetStore();
                console.log('recruitmentResolve');
                var resultRecruitment = result.data.insert_recruitment_info.returning[0];
                return Promise.resolve(resultRecruitment);
              }).catch(function (error) {
                console.log('recruitmentError');
                return Promise.reject(error);
              });
            case 1:
              return _context3.abrupt("return", _context3.sent);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function insertRecruitment(_x) {
        return _insertRecruitment.apply(this, arguments);
      }
      return insertRecruitment;
    }(),
    postFormSubmit: function () {
      var _postFormSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(form) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.loading = true;
              this.waitDialogVisible = true;
              _context4.next = 1;
              return this.insertRecruitment(form).then(function (resultRecruitment) {
                _this.loading = false;
                _this.waitDialogVisible = false;
                _this.$notify({
                  title: '成功',
                  message: '求人情報を作成しました',
                  type: 'success',
                  duration: 5000
                });
                return _this.$router.push({
                  name: 'RecruitmentIndex'
                });
              }).catch(function (error) {
                console.log(error);
                _this.loading = false;
                _this.waitDialogVisible = false;
                _this.$notify({
                  title: '失敗',
                  message: '求人情報を作成できませんでした',
                  type: 'error',
                  duration: 5000
                });
              });
            case 1:
              return _context4.abrupt("return", _context4.sent);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function postFormSubmit(_x2) {
        return _postFormSubmit.apply(this, arguments);
      }
      return postFormSubmit;
    }()
  }
};